import { useDisclosure } from '@chakra-ui/react';

import ExcelCellsSourceModal from 'components/ExcelCellsSourceModal';
import Menu from 'ui/Menu';

import { useOfficeContext } from '../../../utils/addin/office';
import { useCurrentUser } from '../../../utils/user';
import NewDiagramFromTemplateModal from '../../NewDiagramFromTemplateModal';
import BlockedMenuItem from '../BlockedMenuItem';
import TrackedMenuItem from '../TrackedMenuItem';

const NewDiagramMenuItem: React.FC = () => {
  const templatesDisclosure = useDisclosure();
  const excelDisclosure = useDisclosure();
  const { isExcel } = useOfficeContext();
  const { user } = useCurrentUser();

  if (!user?.can_create_sankeys) {
    return (
      <BlockedMenuItem
        label="New"
        value="new-diagram"
        conversionTriggerAction="Creating"
        upgradeMessage="To create a new diagram please upgrade your subscription or delete some of your existing diagrams to free up more diagram slots."
      />
    );
  }

  if (isExcel) {
    return (
      <Menu.Root positioning={{ placement: 'right-start' }}>
        <Menu.TriggerItem value="new-diagram">New</Menu.TriggerItem>
        <Menu.Content>
          <TrackedMenuItem
            value="new-from-excel"
            onClick={excelDisclosure.onOpen}
          >
            From data in this spreadsheet
          </TrackedMenuItem>
          <TrackedMenuItem
            value="new-from-template"
            onClick={templatesDisclosure.onOpen}
          >
            Browse templates
          </TrackedMenuItem>
          <ExcelCellsSourceModal isCreating {...excelDisclosure} />
          <NewDiagramFromTemplateModal {...templatesDisclosure} />
        </Menu.Content>
      </Menu.Root>
    );
  }

  return (
    <>
      <TrackedMenuItem
        value="new-from-template"
        onClick={templatesDisclosure.onOpen}
      >
        New
      </TrackedMenuItem>
      <NewDiagramFromTemplateModal {...templatesDisclosure} />
    </>
  );
};

export default NewDiagramMenuItem;
